// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":1,"societaId":1,"etichetta":"...","note":null,"stato":"CARICATO","utenteName":"...","totaleFile":3,"fileElaborati":0,"fileErrore":0,"ordiniCreati":0,"righeCreate":0,"righeNonRisolte":0,"createdAt":"...","insegna":{"id":1,"codice":"BC","nome":"Bricocenter"},"file":[{"id":1,"nomeFile":"ordini.xml","tipoFile":"XML","dimensioneByte":12345,"hashSha256":"...","gcsPath":"...","stato":"CARICATO","erroreMessaggio":null,"ordiniEstratti":0,"righeEstratte":0,"createdAt":"..."}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini/:id/log',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"utenteName":"...","azione":"Creazione caricamento","dettaglio":"...","createdAt":"..."}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini/:id/ordini',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"numeroOrdine":"26008635","codiceNegozio":"0032","nomeNegozio":"CINISELLO","cittaNegozio":"CINISELLO BALSAMO","nomeDeposito":"DEPOSITO RIVALTA KTN","dataConsegnaDa":"...","totaleDichiarato":"72.930","note":null,"matchNegozio":"NESSUNO","stato":"DA_VERIFICARE","righeTotali":2,"righeNonRisolte":2,"righe":[],"cliente":null,"filiale":null}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini/:id/articoli-smartix?q=',
    requestBody: null,
    response: '{"success":true,"data":[{"id":48,"codice":"XST-SCOLAC60","descrizioneBase":"...","ean":"8053017891811"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini/:id/negozi',
    requestBody: null,
    response: '{"success":true,"data":[{"id":21,"codice":"NOM00018","ragioneSociale":"Bricocenter Italia spa","filiali":[{"id":3,"nome":"CINISELLO","citta":"CINISELLO BALSAMO"}]}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/bop-go/import-ordini/:id/elabora',
    requestBody: null,
    response: '{"success":true,"data":{"fileElaborati":4,"fileErrore":0,"fileSaltati":[],"ordiniTotali":37,"righeTotali":112,"righeNonRisolte":0,"codiciInsegnaImparati":0,"articoliInIndice":0,"clientiInsegna":0,"avvisi":[],"quadratura":{"ordiniAttesi":37,"ordiniEstratti":37,"totaleAtteso":4154.79,"mancanti":[],"quadra":true}}}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini/:id/ordini/:ordineId/anteprima-go',
    requestBody: null,
    response: '{"success":true,"data":{"documento":{"causale_documento":"C1S","riferimento":"LEROY MERLIN 041 63895032","cliente":"00000038","indirizzo":"00000041","data_documento":"2026-09-04T00:00:00.000Z","data_consegna":"2026-09-10T00:00:00.000Z","righe":[{"articolo":"XST-SCP90","quantita":2}]},"problemi":[]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/bop-go/import-ordini/:id/invia-go',
    requestBody: null,
    response: '{"success":true,"data":{"daInviare":20,"inviati":20,"falliti":0,"dettagli":[{"numeroOrdine":"63895032","ok":true,"progressivo":"12345"}]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/bop-go/import-ordini/:id/rileva-go',
    requestBody: null,
    response: '{"success":true,"data":{"daRilevare":20,"rilevati":20,"falliti":0,"dettagli":[{"numeroOrdine":"63895032","ok":true,"goNumeroDocumento":"SM 2318","goRighe":2,"goImponibile":190.5,"goTotale":232.41,"goSituazione":"inserito"}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini/:id/prospetto.pdf',
    requestBody: null,
    response: 'file binario'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/import-ordini/:id/file/:fileId',
    requestBody: null,
    response: 'file binario'
  },
  {
    method: 'DELETE',
    endpoint: '/api/bop-go/import-ordini/:id',
    requestBody: null,
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
